import { Button } from '@tremor/react';
import { FC, HTMLProps, useRef } from 'react';
import { SearchIcon } from '@/assets';
import { RiCloseLine } from '@remixicon/react';

type InsideForm = {
  onSubmit?: (searchValue: string) => void;
  form?: never;
  insideForm?: never;
};

type OutsideForm = {
  form: string;
  onSubmit?: never;
  insideForm?: boolean;
};
type Props = (InsideForm | OutsideForm) & {
  placeholder?: string;
  cancelButton?: boolean;
} & Omit<HTMLProps<HTMLInputElement>, 'onSubmit'>;

export type FormValues = {
  search: { value: string };
};

export const SearchBar: FC<Props> = ({
  onSubmit,
  placeholder = '',
  insideForm = true,
  form,
  disabled,
  style,
  cancelButton = false,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDeleteSearch = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
      onSubmit?.('');
    }
  };

  return insideForm ? (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const target = e.target as typeof e.target & FormValues;
        const searchValue = target.search.value;
        onSubmit?.(searchValue);
      }}
      style={style}
      className="flex items-center w-72 h-10 bg-white border-[#E7EAEC] border-solid border rounded-xl relative"
    >
      <Button
        form={form}
        className="w-10 h-10 flex justify-center items-center p-0 border-none bg-primary-default rounded-l-xl transition-color duration-200 hover:bg-secondary-default rounded-r-none"
        icon={() => <img src={SearchIcon} alt="search icon" />}
        disabled={disabled}
      ></Button>
      <input
        ref={inputRef}
        form={form}
        name="search"
        className="bg-white flex-1 flex w-full h-full border-none outline-none rounded-r-xl text-[#9E9E9E] font-ubuntu font-weight-400 text-base pl-4"
        type="text"
        placeholder={placeholder}
        disabled={disabled}
        {...rest}
      />
      {cancelButton ? (
        <Button
          onClick={handleDeleteSearch}
          className="bg-white p-0 flex h-full w-10 border-none outline-none shadow-none hover:bg-white rounded-xl"
        >
          <RiCloseLine size="1rem" color="black" />
        </Button>
      ) : null}
    </form>
  ) : (
    <div className="flex items-center w-72 h-10 bg-white border-[#E7EAEC] border-solid border rounded-xl relative">
      <Button
        form={form}
        className="w-10 h-10 flex justify-center items-center p-0 border-none bg-primary-default rounded-l-xl transition-color duration-200 hover:bg-secondary-default rounded-r-none"
        icon={() => <img src={SearchIcon} alt="search icon" />}
        disabled={disabled}
      ></Button>
      <input
        ref={inputRef}
        form={form}
        name="search"
        className="bg-white flex-1 flex w-full h-full border-none outline-none rounded-r-xl text-[#9E9E9E] font-ubuntu font-weight-400 text-base pl-4"
        type="text"
        placeholder={placeholder}
        disabled={disabled}
        {...rest}
      />
      {cancelButton ? (
        <Button
          onClick={handleDeleteSearch}
          className="bg-white p-0 flex h-full w-10 border-none outline-none shadow-none hover:bg-white rounded-xl"
        >
          <RiCloseLine size="1rem" color="black" />
        </Button>
      ) : null}
    </div>
  );
};
